<template>
  <div>
    <v-snackbar :timeout="-1" v-model="visible">
      {{ text }}
      <v-btn color="secondary" text @click="this.close">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "Snackbar",
  props: {
    visible: {
      type: Boolean,
    },
    text: {
      type: String,
      default: "Sin mensaje",
    },
  },
  data() {
    return {};
  },
  watch: {
    visible() {
      this.closeAuto();
    },
  },
  mounted() {
    this.closeAuto();
  },
  methods: {
    ...mapActions(["alertSnackbar"]),
    closeAuto() {
      setTimeout(() => {
        this.alertSnackbar({ snackbar: false });
      }, 2500);
    },
    close() {
      this.alertSnackbar({
        snackbar: false,
        text: "null",
      });
    },
  },
  computed: {},
};
</script>
<style></style>
